import { render, staticRenderFns } from "./SuggestionsFilter.vue?vue&type=template&id=4485dc32&scoped=true"
import script from "./SuggestionsFilter.vue?vue&type=script&lang=js"
export * from "./SuggestionsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485dc32",
  null
  
)

export default component.exports